define((require) => {
    'use strict';

    const FormLayer = require('system/blocks/form-layer/form-layer');

    return FormLayer.extend('billing-registration__stage-finish', {
        inner: true,
        renderMode: 'replace',
        service: false,

        title: 'Дорегистрация завершена',

        onClose() {
            this.emit('cancel');
        },

        width: 420,

        mods: [
            'centered-header',
            'billing-registration',
            'billing-registration__stage-finish',
        ],

        buttons: [
            {
                name: 'close',
                text: 'Закрыть',
                mods: ['main'],
            },
        ],

        fields: [
            {
                columns: [
                    {
                        block: 'billing-registration__finish-message',
                    },
                ],
            },
        ],
    });
});
